import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { MetricsSubspaceName } from '../../state/SpaceInfo';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { MetricDetailSpace } from './MetricDetailSpace';
import { MetricsSpaceProvider, MetricsSpaceProviderProps } from './MetricsSpaceProvider';

export interface MetricsSpaceRouterProps extends ReactDirectiveProps {
  readonly urls: SpacesSiteUrls;
}

export class MetricsSpaceRouter extends React.Component<MetricsSpaceRouterProps> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.metricsAllPath()} render={this.provider('all')} />
        <Route exact path={this.props.urls.metricsFavoritesPath()} render={this.provider('favorites')} />
        <Route exact path={this.props.urls.metricsOwnedPath()} render={this.provider('owned')} />
        <Route path={this.props.urls.metricPath(':id')} render={({match}) => <MetricDetailSpace luid={match.params.id} urls={this.props.urls} /> }/>
        <Route exact path={this.props.urls.metricsPath()} render={() => (
          <Redirect to={this.props.urls.metricsFavoritesPath()} />
        )} />
        <Route render={this.error} />
      </Switch>
    );
  }

  private provider = (subspaceName: MetricsSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (props: RouteComponentProps): JSX.Element => {
      const metricsSpaceProviderProps: MetricsSpaceProviderProps = {
        activeSubspaceName: subspaceName,
        routeLocationSearch: props.location.search,
        routeLocationPath: props.location.pathname,
        urls: this.props.urls,
        angularContext: this.props.angularContext,
      };

      return <MetricsSpaceProvider {...metricsSpaceProviderProps} />;
    };
  }

  private error = (): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }
}
